<template>
  <aside class="legacy-sunset-banner" aria-label="Legacy interface retirement announcement">
    <div class="legacy-sunset-banner__message">
      <strong>This legacy interface will retire in December 2026.</strong>
      <span>Start using V3 today to get ready for the switch.</span>
    </div>
    <a class="legacy-sunset-banner__cta" :href="v3Url">
      Try V3 <span aria-hidden="true">&rarr;</span>
    </a>
  </aside>
</template>

<script>
import { getV3Url } from '@/utils/v3Migration'

export default {
  name: 'LegacySunsetBanner',
  computed: {
    v3Url() {
      return getV3Url(this.$route, window.location)
    }
  },
  mounted() {
    this.$nextTick(this.updateHeight)
    window.addEventListener('resize', this.updateHeight)
    if (window.ResizeObserver) {
      this.resizeObserver = new window.ResizeObserver(this.updateHeight)
      this.resizeObserver.observe(this.$el)
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateHeight)
    if (this.resizeObserver) this.resizeObserver.disconnect()
  },
  methods: {
    updateHeight() {
      this.$el.parentElement.style.setProperty('--legacy-banner-height', this.$el.offsetHeight + 'px')
    }
  }
}
</script>

<style>
.legacy-sunset-banner {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1040;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px 24px;
  padding: 12px 20px;
  background: #1a1a1a;
  color: #fff;
  border-bottom: 3px solid #a3ff12;
  font-family: 'Open Sans', sans-serif;
  font-size: 14px;
  line-height: 1.5;
}
.legacy-sunset-banner__message {
  display: flex;
  flex-wrap: wrap;
  gap: 2px 8px;
}
.legacy-sunset-banner__cta,
.legacy-sunset-banner__cta:visited {
  flex-shrink: 0;
  padding: 8px 16px;
  border-radius: 6px;
  background: #a3ff12;
  color: #1a1a1a;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
}
.legacy-sunset-banner__cta:hover {
  background: #baff50;
  color: #1a1a1a;
  text-decoration: none;
}
.legacy-sunset-banner__cta:focus-visible {
  outline: 3px solid #fff;
  outline-offset: 3px;
}
.legacy-app {
  padding-top: var(--legacy-banner-height, 67px);
}
.legacy-app .legacy-workspace .kobe-app-bar,
.legacy-app .legacy-workspace > .v-application--wrap > .v-navigation-drawer {
  top: var(--legacy-banner-height, 67px) !important;
}
.legacy-app .legacy-workspace > .v-application--wrap > .v-navigation-drawer {
  height: calc(100% - var(--legacy-banner-height, 67px)) !important;
}
.legacy-app .v-application--wrap {
  min-height: calc(100vh - var(--legacy-banner-height, 67px));
}
@media (max-width: 600px) {
  .legacy-sunset-banner {
    gap: 12px;
    padding: 10px 12px;
    font-size: 12px;
  }
  .legacy-sunset-banner__message {
    display: block;
  }
  .legacy-sunset-banner__message strong,
  .legacy-sunset-banner__message span {
    display: block;
  }
  .legacy-sunset-banner__cta {
    padding: 8px 12px;
  }
}
@media print {
  .legacy-sunset-banner { display: none; }
  .legacy-app { padding-top: 0; }
}
</style>



// WEBPACK FOOTER //
// LegacySunsetBanner.vue?34c548e2